import { __awaiter, __extends, __generator } from "tslib";
import Manager from '../Abstracts/Manager';
var AuthManager = /** @class */ (function (_super) {
    __extends(AuthManager, _super);
    function AuthManager(urlrefreshtoken, client_id, clientSecret, storageManager) {
        var _this = _super.call(this) || this;
        _this.handleNoTokenFound = function () { };
        _this.token = undefined;
        _this.urlToken = urlrefreshtoken;
        _this.clientSecret = clientSecret;
        _this.storage = storageManager;
        _this.clientId = client_id;
        _this.clearToken = _this.clearToken.bind(_this);
        _this.getTokenFromDisk = _this.getTokenFromDisk.bind(_this);
        _this.refreshToken = _this.refreshToken.bind(_this);
        return _this;
    }
    AuthManager.prototype.setToken = function (newToken, callback) {
        var _this = this;
        if (callback === void 0) { callback = function () { }; }
        this.storage
            .store(this.storage.PREFERENCES.TOKEN, newToken)
            .then(function (success) {
            _this.token = newToken;
            callback(success);
        });
    };
    AuthManager.prototype.clearToken = function (onSuccess, onError) {
        if (onSuccess === void 0) { onSuccess = function () { }; }
        if (onError === void 0) { onError = function () { }; }
        this.token = undefined;
        this.storage.remove(this.storage.PREFERENCES.TOKEN, onSuccess, onError);
    };
    AuthManager.prototype.getTokenFromDisk = function () {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.token) return [3 /*break*/, 1];
                        return [2 /*return*/, this.token];
                    case 1: return [4 /*yield*/, this.storage.fetch(this.storage.PREFERENCES.TOKEN)];
                    case 2:
                        token = _a.sent();
                        if (token && token.access_token) {
                            this.token = token;
                            return [2 /*return*/, token];
                        }
                        else {
                            return [2 /*return*/, undefined];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AuthManager.prototype.handleUnauthorized = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!_this.token) {
                            _this.handleNoTokenFound();
                        }
                        else {
                            _this.storage
                                .fetch(_this.storage.PREFERENCES.CONNECTION_METHOD)
                                .then(function (value) { return resolve(_this.refreshToken(_this.token.refresh_token, value)); });
                        }
                    })];
            });
        });
    };
    AuthManager.prototype.refreshToken = function (refreshToken, clientId) {
        if (clientId === void 0) { clientId = this.clientId; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        fetch(_this.urlToken, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: "grant_type=refresh_token&" +
                                ("client_id=" + clientId + "&") +
                                ("client_secret=" + _this.clientSecret + "&") +
                                ("refresh_token=" + refreshToken)
                        })
                            .then(function (response) {
                            return response.json();
                        })
                            .then(function (json) {
                            // We know that it is the correct response, not an error
                            if (json.access_token) {
                                // Storing the response (token and refresh) on disk
                                _this.setToken(json);
                                resolve(json.access_token);
                            }
                            else if (!json || (json.Errors[0].errors[0].exception.message && json.Errors[0].errors[0].exception.Message.error.includes('invalid_grant'))) {
                                _this.handleNoTokenFound();
                            }
                            return json;
                        })
                            .catch(function (error) {
                            _this.handleNoTokenFound();
                        });
                    })];
            });
        });
    };
    return AuthManager;
}(Manager));
export default AuthManager;
